import { from, HttpLink } from '@apollo/client';
import { authLink } from './authLink';

export const createHttpLink = (url) => {
  const httpLink = new HttpLink({
    uri: url
  });

  return from([authLink, httpLink]);
};
